export default {
    methods: {
        on_pay_deposit_pre(item) {
            return this.$router.push("/cashier_trademark?order_no=" + item.order_no);

            // let content = `订单号：${item.order_no}，定金金额：${item.amount_deposit}元`;
            // this.$event_bus.$emit(
            //     "password_pay",
            //     (e) => {
            //         this.password_pay = e;
            //         this.on_pay_deposit(item);
            //     },
            //     content
            // );
        },
        on_pay_deposit(item) {
            this.$http
                .post("/order_trademark/step_deposit", { order_no: item.order_no, password_pay: this.password_pay })
                .then((res) => {
                    if (res.success) {
                        this.$alert(res.message, "成功", { type: "success" });
                        this.load();
                    } else {
                        this.$alert(res.message, "失败", { type: "error" });
                    }
                })
                .catch(() => {})
                .then(() => {});
        },
        //验店
        on_verify_pre(item) {
            this.$confirm("请确定您已经完成了验店（本次操作不会扣除任何费用）", "操作确认", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
                type: "info",
            }).then(() => {
                this.on_verify(item);
            });
            // let content = `请确定您已经完成了验店（本次操作不会扣除任何费用）`;
            // this.$event_bus.$emit(
            //     "password_pay",
            //     (e) => {
            //         this.password_pay = e;
            //         this.on_verify(item);
            //     },
            //     content
            // );
        },
        on_verify(item) {
            this.$http
                .post("/order_trademark/step_verify", { order_no: item.order_no, password_pay: this.password_pay })
                .then((res) => {
                    if (res.success) {
                        this.$alert(res.message, "成功", { type: "success" });
                        this.load();
                    } else {
                        this.$alert(res.message, "失败", { type: "error" });
                    }
                })
                .catch(() => {})
                .then(() => {});
        },
        //尾款
        on_balance_pre(item) {
            let content = `订单号：${item.order_no}，尾款金额：${item.amount - item.amount_deposit}元`;
            this.$event_bus.$emit(
                "password_pay",
                (e) => {
                    this.password_pay = e;
                    this.on_balance(item);
                },
                content
            );
        },
        on_balance(item) {
            this.$http
                .post("/order_trademark/step_balance", { order_no: item.order_no, password_pay: this.password_pay })
                .then((res) => {
                    if (res.success) {
                        this.$alert(res.message, "成功", { type: "success" });
                        this.load();
                    } else {
                        this.$alert(res.message, "失败", { type: "error" });
                    }
                })
                .catch(() => {})
                .then(() => {});
        },
    },
};
